(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-404"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ok) return; root.dataset.ok = '1';
      var wins = [].slice.call(root.querySelectorAll('[data-win]'));
      var cover = root.querySelector('[data-cover]'), msg = root.querySelector('[data-msg]'), start = root.querySelector('[data-start]');
      var elScore = root.querySelector('[data-score]'), elTime = root.querySelector('[data-time]'), elBest = root.querySelector('[data-best]');
      var best = 0, score = 0, left = 30, jugando = false, reloj = null, salida = null, last = -1;
      try { best = +localStorage.getItem('cc-404-record') || 0; } catch (e) {}
      elBest.textContent = best;
      function asoma() {
        if (!jugando) return;
        var libres = wins.filter(function (w, k) { return !w.classList.contains('is-up') && k !== last; });
        var w = libres[Math.floor(Math.random() * libres.length)];
        last = wins.indexOf(w);
        w.classList.remove('is-hit'); w.classList.add('is-up');
        var dura = Math.max(520, 1100 - score * 22);
        w._t = setTimeout(function () { w.classList.remove('is-up'); }, dura);
        salida = setTimeout(asoma, Math.max(380, 820 - score * 16));
      }
      function fin() {
        jugando = false; clearInterval(reloj); clearTimeout(salida);
        wins.forEach(function (w) { clearTimeout(w._t); w.classList.remove('is-up'); w.tabIndex = -1; });
        var nuevo = score > best;
        if (nuevo) { best = score; elBest.textContent = best; try { localStorage.setItem('cc-404-record', best); } catch (e) {} }
        var frase = score >= 25 ? '¡Tu casa brilla! ' : score >= 15 ? '¡Qué buena mano limpiando! ' : score >= 6 ? '¡Nada mal! ' : '¡Las pelusas son rápidas! ';
        msg.textContent = frase + 'Has atrapado ' + score + (score === 1 ? ' pelusa.' : ' pelusas.') + (nuevo && score > 0 ? ' ¡Nuevo récord!' : '');
        start.textContent = 'Jugar otra vez';
        cover.hidden = false; start.focus();
      }
      start.addEventListener('click', function () {
        score = 0; left = 30; elScore.textContent = 0; elTime.textContent = 30;
        cover.hidden = true; jugando = true;
        wins.forEach(function (w) { w.tabIndex = 0; });
        reloj = setInterval(function () { left--; elTime.textContent = left; if (left <= 0) fin(); }, 1000);
        salida = setTimeout(asoma, 400);
      });
      wins.forEach(function (w) {
        w.addEventListener('pointerdown', function (e) {
          if (!jugando || !w.classList.contains('is-up')) return;
          e.preventDefault();
          clearTimeout(w._t);
          w.classList.remove('is-up'); w.classList.add('is-hit');
          score++; elScore.textContent = score;
          setTimeout(function () { w.classList.remove('is-hit'); }, 600);
        });
        w.addEventListener('keydown', function (e) {
          if ((e.key === 'Enter' || e.key === ' ') && jugando && w.classList.contains('is-up')) { e.preventDefault(); w.dispatchEvent(new Event('pointerdown')); }
        });
      });
    }
    function todo() { document.querySelectorAll('[data-cc-404]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
    document.addEventListener('shopify:section:load', todo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-detalle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ok) return; root.dataset.ok = '1';
      var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } });
      }, { threshold: .2 }) : null;
      if (io) io.observe(root); else root.classList.add('is-in');
      var stage = root.querySelector('[data-stage]'); if (!stage) return;
      var slides = [].slice.call(stage.querySelectorAll('[data-slide]'));
      var ths = [].slice.call(root.querySelectorAll('[data-th]'));
      var cur = root.querySelector('[data-cur]'), bar = root.querySelector('[data-bar]');
      var i = +root.dataset.start || 0, n = slides.length, timer = null, parado = false;
      var quieto = matchMedia('(prefers-reduced-motion: reduce)').matches, T = 4500;
      function ir(k, manual) {
        i = (k + n) % n;
        slides.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
        ths.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
        if (ths[i]) ths[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        if (cur) cur.textContent = i + 1;
        stage.classList.remove('is-zoom');
        if (manual) parado = true;
        programa();
      }
      function programa() {
        clearTimeout(timer);
        if (bar) { bar.classList.remove('is-run'); void bar.offsetWidth; }
        if (parado || quieto || n < 2) return;
        if (bar) bar.classList.add('is-run');
        timer = setTimeout(function () { ir(i + 1); }, T);
      }
      if (n < 2) return;
      root.style.setProperty('--cc-det-t', T / 1000 + 's');
      root.querySelector('[data-prev]').addEventListener('click', function () { ir(i - 1, true); });
      root.querySelector('[data-next]').addEventListener('click', function () { ir(i + 1, true); });
      ths.forEach(function (t, j) { t.addEventListener('click', function () { ir(j, true); }); });
      stage.addEventListener('mouseenter', function () { clearTimeout(timer); if (bar) bar.classList.remove('is-run'); });
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); programa(); });
      if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
        stage.addEventListener('click', function (e) {
          if (e.target.closest('button')) return;
          stage.classList.toggle('is-zoom'); parado = true;
        });
        stage.addEventListener('mousemove', function (e) {
          var r = stage.getBoundingClientRect(), img = slides[i].querySelector('img');
          if (img) img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
      }
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) ir(i + (dx < 0 ? 1 : -1), true);
      });
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else programa(); });
      var vis = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) programa(); else clearTimeout(timer); });
      }, { threshold: .3 }) : null;
      if (vis) vis.observe(stage); else programa();
    }
    function todo() { document.querySelectorAll('[data-cc-det]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
    document.addEventListener('shopify:section:load', todo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
